import { h, Component } from 'preact';
import {classNames} from 'lib/helpers'
import style from './style.less'
export default (props)=>{
    let classes = [style.link]
    props.class && classes.push(props.class)
    props.noStyle && classes.push(style.noStyle)

    const onClick = (...attrs)=>{
        attrs[0].preventDefault()
        if(props.onClick) props.onClick(...attrs)
    }
    return <a href='#' onClick={onClick} class={classNames(classes)}>{props.children}</a>
}


// WEBPACK FOOTER //
// ./components/elements/Link/index.js